/* eslint-disable */
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

const CompanyListHeader = ({
  reloadCompanyList = () => {},
  updateRankHandler = () => {},
  jsonFilterQuery = [],
  selectedCompanyIds = [],
  downloadAsExcel = () => {},
  showPivotView = false,
  setShowPivotView = () => {},
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();
  const breadcrumbTxt = [{ title: t("Company") }];

  return (
    <div className="bg-white py-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbTxt} top={false} />
        </div>

        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          <Link
            onClick={reloadCompanyList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>

          {/* Pivot toggle button: placed just before the Action dropdown */}
          <button
            type="button"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            onClick={() => setShowPivotView((prev) => !prev)}
            title={showPivotView ? t("Table View") : t("Pivot View")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              pivot_table_chart
            </span>
            <span className="fw-semibold small">
              {showPivotView ? t("Table View") : t("Pivot View")}
            </span>
          </button>

          {/* ------- action section ---------- */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>

            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedCompanyIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  data-bs-toggle={
                    selectedCompanyIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedCompanyIds.length === 0
                      ? undefined
                      : "#addLabelModal"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">{t("Manage Label")}</span>
                </Link>
              </li>{" "}
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedCompanyIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedCompanyIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedCompanyIds.length === 0 ? undefined : "#addToList"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    list
                  </span>
                  <span className="d-block">{t("Add To List")}</span>
                </Link>
              </li>
              {/* ----- update rank section start -----  */}
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedCompanyIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  onClick={() => {
                    if (selectedCompanyIds.length > 0) {
                      updateRankHandler();
                    }
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    progress_activity
                  </span>
                  <span className="d-block">{t("Update Rank")}</span>
                </Link>
              </li>
              {/* assign company bulk user  */}
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedCompanyIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  data-bs-toggle={
                    selectedCompanyIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedCompanyIds.length === 0
                      ? undefined
                      : "#assignCompanyMemberModal"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    person_add
                  </span>
                  <span className="d-block">{t("Assign Member")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedCompanyIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  data-bs-toggle={
                    selectedCompanyIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedCompanyIds.length === 0
                      ? undefined
                      : "#assignGroupModal"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    group_add
                  </span>
                  <span className="d-block">{t("Assign Group")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedCompanyIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  data-bs-toggle={
                    selectedCompanyIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedCompanyIds.length === 0
                      ? undefined
                      : "#addFollowers"
                  }
                  onClick={() => {
                    if (selectedCompanyIds.length === 0) {
                      return;
                    }
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    person_add
                  </span>
                  <span className="d-block">{t("Add Followers")}</span>
                </Link>
              </li>
              {/* ----- update rank section end -----  */}
              <hr className="dropdown-divider" />
              {/* ----- download as excel section start -----  */}
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2 "
                  onClick={downloadAsExcel}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    download
                  </span>
                  <span className="d-block">{t("Download as Excel")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  data-bs-toggle="modal"
                  data-bs-target="#csvUploadModal"
                >
                  <span className="d-block material-symbols-outlined icon-md">
                    upload
                  </span>
                  <span className="d-block">{t("CSV/XLS Upload")}</span>
                </Link>
              </li>
              {/* ----- download as excel section end -----  */}
              <hr className="dropdown-divider" />
              {/* -------- delete ----------- */}
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2  ${
                    selectedCompanyIds.length === 0
                      ? "disabled text-muted"
                      : "text-danger"
                  }`}
                  data-bs-toggle={
                    selectedCompanyIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedCompanyIds.length === 0
                      ? undefined
                      : "#deletewarning"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete")}</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* --------- filter ---------- */}
          <Link
            to="#"
            className={`btn ${
              jsonFilterQuery.length > 0
                ? "btn-outline-primary"
                : "btn-light border"
            } d-flex align-items-center px-4 py-2 rounded-3 shadow-sm`}
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasCompanyListFilter"
            aria-controls="offcanvasCompanyListFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
            <span
              className={
                jsonFilterQuery.length > 0
                  ? "bg-primary text-white ms-1 rounded-circle fs-xs"
                  : "d-none"
              }
              style={{ minWidth: 22, minHeight: 22 }}
            >
              {jsonFilterQuery.length}
            </span>
          </Link>

          {/* ----------- add new ------------ */}
          <Link
            to="/admin/companies/info"
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span>{t("Add New")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CompanyListHeader;
